import script from "./salesRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./salesRecords.vue?vue&type=script&setup=true&lang=js"

import "./salesRecords.vue?vue&type=style&index=0&id=98055d0a&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98055d0a"]])

export default __exports__